// @flow

import React, {Children, cloneElement} from 'react';
import {hashedClasses} from '@pb/kit-util-with-css-module';
import styles from './carousel-item.module.styl';

import type {Node, StatelessFunctionalComponent} from 'react';

const classes = hashedClasses(styles);

type CarouselItemStyle = {[key: string]: Object } | number | false | null;

type Props = {|
    id: string,
    getRef?: (el: ?HTMLElement) => void,
    style?: CarouselItemStyle,
    initAddAnimation?: (id: string) => void,
    initRemoveAnimation?: (id: string) => void,
    children: Node,
|};

export const CarouselItem: StatelessFunctionalComponent<Props> = props => (
    <div ref={props.getRef} className={classes['carousel-item']} style={props.style}>
        {Children.map(props.children, (child => cloneElement(child, {
            initAddAnimation: props.initAddAnimation,
            initRemoveAnimation: props.initRemoveAnimation
        })))}
    </div>
);
